// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';
import { createRoot } from 'react-dom/client';
import parse from 'html-react-parser';

// Material UI ( mui )  components
import Box from '@mui/material/Box';

// Section for import custom components --------------------------------------------------------------------------------
import Header from '@components/layout/Header';
import Footer from '@components/layout/Footer';
import MansionNavigation from '@components/MansionNavigation';
import Breadcrumbs from '@components/common/Breadcrumbs';
import MansionNavigationProps from '@/types/components/MansionNavigation/MansionNavigationProps';
import App from './app';

const targetId = 'app-content-stations';

// Section for render component ----------------------------------------------------------------------------------------

// Render component if the targetId element exists in the DOM.
if (document.getElementById(targetId)) {
  const container = document.getElementById(targetId)!;
  const root = createRoot(container);

  // load blade html element
  const children = parse(container.innerHTML);

  const { props } = container.dataset;
  const propsData: MansionNavigationProps = JSON.parse(props!);
  const { isPrefectureSelect } = propsData;
  const { selectedPrefecture } = propsData;
  const { isCitySelect } = propsData;
  const { selectedCity } = propsData;
  const { isLineSelect } = propsData;
  const { selectedLine } = propsData;
  const { typeNavigation } = propsData;
  const breadcrumbs = container.dataset.breadcrumbs ? JSON.parse(container.dataset.breadcrumbs) : [];

  root.render(
    <App>
      <Header />
      {children}
      <Box>
        <MansionNavigation
          isPrefectureSelect={isPrefectureSelect}
          selectedPrefecture={selectedPrefecture}
          isCitySelect={isCitySelect}
          selectedCity={selectedCity}
          isLineSelect={isLineSelect}
          selectedLine={selectedLine}
          typeNavigation={typeNavigation}
          mansionsData={null}
          navigationName="stations"
        />
      </Box>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <Footer />
    </App>,
  );
}
